import { render, staticRenderFns } from "./SidePanelRatesColor.vue?vue&type=template&id=2d721cb6&scoped=true&"
import script from "./SidePanelRatesColor.vue?vue&type=script&lang=js&"
export * from "./SidePanelRatesColor.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelRatesColor.vue?vue&type=style&index=0&id=2d721cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d721cb6",
  null
  
)

export default component.exports